import React from 'react';

const NavBar = (props) => {
  const {editMode, setEditMode} = props;
  const handleSetEdit = () => {
    setEditMode(!editMode)
  }
  return (
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div className="edit-container">
          Edit Mode
          <label class="switch">
  <input type="checkbox" value={!editMode} onChange={handleSetEdit} />
  <span class="slider round"></span>
</label>
        </div>
        {/* <form class="d-flex">
          <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
          <button class="btn btn-outline-success" type="submit">Search</button>
        </form> */}
      </div>
    </div>
    
  </nav>
  );
};

export default NavBar;  